import { render, staticRenderFns } from "./GBTerm.vue?vue&type=template&id=3692dbee&"
import script from "./GBTerm.vue?vue&type=script&lang=js&"
export * from "./GBTerm.vue?vue&type=script&lang=js&"
import style0 from "./GBTerm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/demo/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VTooltip})
